import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { RepeatIcon } from "@chakra-ui/icons";
import { useZoomPan } from "./hooks/useZoomPan";
import { useSvgAreaHandlers } from "./hooks/useSvgAreaHandlers";
export default function TableSvgRenderer({ svgUrl, sectionImages, areaNames, minLadiesRequired, femaleCount, lowestPriceAreaName, onAreaClick, onInsufficientLadiesClick, minZoom = 0.5, maxZoom = 5, }) {
    const [svgText, setSvgText] = useState(null);
    const containerRef = useRef(null);
    // Zoom and pan functionality
    const { scale, position, isDragging, handleMouseDown, handleMouseMove, handleMouseUp, handleTouchStart, handleTouchMove, handleTouchEnd, handleWheel, resetZoom, } = useZoomPan(minZoom, maxZoom);
    // SVG area click handlers and styling
    useSvgAreaHandlers({
        svgText,
        containerRef,
        sectionImages,
        areaNames,
        minLadiesRequired,
        femaleCount,
        lowestPriceAreaName,
        onAreaClick,
        onInsufficientLadiesClick,
    });
    // Load SVG content
    useEffect(() => {
        if (!svgUrl) {
            setSvgText(null);
            return;
        }
        setSvgText(svgUrl);
    }, [svgUrl]);
    if (!svgText)
        return null;
    return (_jsxs(Box, { w: "100%", position: "relative", children: [_jsx("style", { children: `
          #svg-layout-container svg {
            width: 100%;
            max-width: 100%;
            height: auto;
            display: block;
            max-height: 80vh;
          }

          #svg-layout-container svg g[data-selected="true"] {
            opacity: 0.7 !important;
            filter: brightness(1.2);
          }

            .svg-viewport {
            width: 100%;
            height: auto;
            min-height: 100%;
            margin-top: 1rem;
          }

          .svg-content {
            transform-origin: 0 0;
            transition: ${isDragging ? "none" : "transform 0.2s ease"};
          }
        ` }), scale !== 1 && (_jsx(Button, { position: "fixed", bottom: "16px", right: "16px", w: "42px", h: "42px", minW: "42px", p: 0, borderRadius: "full", bg: "rgba(64,64,64,0.8)", backdropFilter: "blur(6px)", color: "white", boxShadow: "0 6px 16px rgba(0,0,0,0.5)", _hover: { bg: "rgba(70,70,70,0.9)" }, _active: { bg: "rgba(90,90,90,0.9)", transform: "scale(0.92)" }, zIndex: 9999, onClick: resetZoom, children: _jsx(RepeatIcon, { boxSize: "20px" }) })), _jsx("div", { className: "svg-viewport", onWheel: handleWheel, onMouseDown: handleMouseDown, onMouseMove: handleMouseMove, onMouseUp: handleMouseUp, onMouseLeave: handleMouseUp, onTouchStart: handleTouchStart, onTouchMove: (e) => handleTouchMove(e, containerRef), onTouchEnd: handleTouchEnd, style: {
                    width: "100%",
                    minHeight: "400px",
                    maxHeight: "80vh",
                    overflow: "hidden",
                    position: "relative",
                    marginTop: "1rem",
                }, children: _jsx("div", { className: "svg-content", style: {
                        transform: `translate(${position.x}px, ${position.y}px) scale(${scale})`,
                        transformOrigin: "0 0",
                        transition: isDragging ? "none" : "transform 0.2s ease",
                    }, children: _jsx("div", { id: "svg-layout-container", ref: containerRef, dangerouslySetInnerHTML: { __html: svgText }, style: {
                            width: "100%",
                            maxWidth: "100vw",
                        } }) }) })] }));
}
